import React from "react";
import { FormattedMessage } from "react-intl";
import { InvitedExpert } from "../../core/api/model";
import { Typography } from "@material-ui/core";
import { DashboardPanelListItem } from "../DashboardPanel";

export interface DashboardInvitedExpertsListItemProps {
  invitedExpert: InvitedExpert;
}

export const DashboardInvitedExpertsListItem = (props: DashboardInvitedExpertsListItemProps) => (

    <DashboardPanelListItem contentSlot={
                              <Typography>
                                <strong>
                                  {props.invitedExpert.email}
                                </strong>
                              </Typography>
                            }
                            actionsSlot={
                              <Typography component='span' variant='body2'>
                                <FormattedMessage id='DashboardExpertsInvitationSend' />
                              </Typography>
                            }
                            actionsAlign='center'
    />
);
